<template>
    <v-container v-if="null != restaurant" fluid>
        <v-row justify="center">
            <v-col md="6">
                <restaurant-edit-form
                    v-bind:title="`Editing restaurant: ${restaurant.name}`"
                    v-bind:restaurant="restaurant"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import restaurantApi from '@/api/restaurantApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'restaurant-edit-form': () =>
            import('@/views/op/RestaurantEditForm.vue')
    },
    data() {
        return {
            restaurant: null
        };
    },
    methods: {
        async submit() {
            const response = await restaurantApi.updateRestaurant(
                this.restaurant.id,
                this.restaurant
            );
            this.$router.push({
                name: 'op-restaurant-show',
                params: { restaurant_id: response.data.restaurant.id }
            });
            snackbar.show('Restaurant updated', 'success');
        }
    },
    async beforeRouteEnter(to, from, next) {
        const restaurantId = to.params.restaurant_id;
        const response = await restaurantApi.getRestaurant(restaurantId);
        next(vm => (vm.restaurant = response.data.restaurant));
    }
};
</script>
